// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + (chunkId === 589 ? "saturday-course-finder" : chunkId) + "." + {"589":"111baa65","675":"b6f2666c","694":"663f46fb","985":"ac22e096"}[chunkId] + ".chunk.css";
};